import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center gap-3 text-left" }

import {
  mdiAlertCircleOutline,
  mdiCheckDecagram,
  mdiMapMarkerRadiusOutline,
  mdiMapSearchOutline
} from '@mdi/js'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitLocationStatus',
  props: {
    confirmed: { type: Boolean },
    verifying: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  emits: ["verify"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LabelBadge, {
      label: _ctx.confirmed ? 'Localização verificada' : 'Localização não verificada',
      color: _ctx.confirmed ? 'green' : 'orange',
      icon: _ctx.confirmed ? _unref(mdiCheckDecagram) : _unref(mdiAlertCircleOutline),
      "data-testid": "location-status-badge"
    }, null, 8, ["label", "color", "icon"]),
    (!_ctx.readonly)
      ? (_openBlock(), _createBlock(OutlinedButton, {
          key: 0,
          text: _ctx.confirmed ? 'Rever no mapa' : 'Verificar localização',
          "prepend-icon": _ctx.confirmed ? _unref(mdiMapSearchOutline) : _unref(mdiMapMarkerRadiusOutline),
          loading: _ctx.verifying,
          disabled: _ctx.verifying,
          width: "auto",
          height: "40px",
          class: "text-sm !w-auto !px-4",
          "data-testid": "verify-location-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('verify')))
        }, null, 8, ["text", "prepend-icon", "loading", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})